import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen"
      style={{ fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif", background: '#000', color: '#F5F5F7' }}>

      {/* ── Nav ── */}
      <nav className="fixed top-0 w-full z-50"
        style={{ background: 'rgba(0,0,0,.8)', backdropFilter: 'saturate(180%) blur(20px)', borderBottom: '1px solid rgba(255,255,255,.08)' }}>
        <div className="max-w-[980px] mx-auto flex items-center justify-between h-12 px-4">
          <div className="flex items-center gap-0.5 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} data-testid="noteho-logo">
            <span className="text-[21px] font-bold tracking-[-0.04em] text-white">NOTE</span>
            <span className="text-[21px] font-bold tracking-[-0.04em]"
              style={{ background: 'linear-gradient(135deg, #FF2D55, #5856D6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>HO</span>
          </div>
          <button onClick={() => navigate('/login')}
            className="text-sm text-white/70 hover:text-white transition-colors"
            data-testid="nav-signin">
            Sign In
          </button>
        </div>
      </nav>

      {/* ── Hero ── */}
      <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 pt-12 overflow-hidden">
        {/* Gradient orbs */}
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] rounded-full opacity-20 blur-[120px]"
          style={{ background: 'linear-gradient(135deg, #FF2D55, #5856D6)' }}/>
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] rounded-full opacity-15 blur-[100px]"
          style={{ background: 'linear-gradient(135deg, #5856D6, #0A84FF)' }}/>

        <div className="relative z-10 max-w-4xl mx-auto">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-8"
            style={{ background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.1)' }}>
            <span className="w-2 h-2 rounded-full" style={{ background: '#30D158' }}/>
            <span className="text-sm text-white/60">WhatsApp-First AI Platform</span>
          </div>

          {/* Brand heading */}
          <h1 className="text-[56px] sm:text-[72px] lg:text-[88px] font-bold leading-[1.05] tracking-[-0.04em] mb-6">
            <span className="text-white">NOTE</span>
            <span style={{ background: 'linear-gradient(135deg, #FF2D55, #AF52DE, #5856D6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>HO</span>
          </h1>

          <p className="text-[21px] sm:text-[28px] font-normal leading-[1.35] tracking-[-0.015em] text-white/60 max-w-2xl mx-auto mb-10">
            AI that understands your business.<br/>
            In Hindi. Telugu. English. On WhatsApp.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={() => navigate('/login')}
              className="px-8 py-3.5 rounded-full text-[17px] font-medium text-white transition-all hover:scale-[1.02]"
              style={{ background: 'linear-gradient(135deg, #FF2D55, #5856D6)' }}
              data-testid="hero-cta">
              Get Started
            </button>
            <button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-3.5 rounded-full text-[17px] font-medium text-white/80 transition-all hover:text-white"
              style={{ background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.15)' }}>
              Learn more
            </button>
          </div>
        </div>

        {/* Mock chat preview */}
        <div className="relative z-10 mt-16 mb-[-80px] max-w-md mx-auto">
          <div className="rounded-[24px] overflow-hidden shadow-2xl p-[2px]"
            style={{ background: 'linear-gradient(135deg, rgba(255,45,85,.3), rgba(88,86,214,.3))' }}>
            <div className="rounded-[22px] overflow-hidden" style={{ background: '#EFEAE2' }}>
              {/* Mini WhatsApp header */}
              <div className="px-4 py-2.5 flex items-center gap-2" style={{ background: '#008069' }}>
                <div className="w-7 h-7 rounded-full flex items-center justify-center" style={{ background: '#2a8e7e' }}>
                  <span className="text-white text-xs font-bold">N</span>
                </div>
                <span className="text-white text-sm font-medium">Noteho AI</span>
                <span className="text-[11px] ml-auto" style={{ color: '#b1ddd3' }}>online</span>
              </div>
              {/* Mini chat bubbles */}
              <div className="p-3 space-y-1.5" style={{ minHeight: 180, backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cdefs%3E%3Cpattern id='p' width='30' height='30' patternUnits='userSpaceOnUse'%3E%3Ccircle cx='15' cy='15' r='.8' fill='%23d4cfc6' fill-opacity='.15'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='120' height='120' fill='url(%23p)'/%3E%3C/svg%3E")` }}>
                <div className="flex justify-end"><div className="px-2.5 py-1.5 rounded-lg text-[13px] max-w-[70%] shadow-sm" style={{ background: '#D9FDD3', color: '#111B21', borderRadius: '7.5px 0 7.5px 7.5px' }}>Ramesh se 15000 aaya cash mein</div></div>
                <div className="flex justify-start"><div className="px-2.5 py-1.5 rounded-lg text-[13px] max-w-[70%] shadow-sm" style={{ background: '#FFF', color: '#111B21', borderRadius: '0 7.5px 7.5px 7.5px' }}>Done! Ramesh se Rs.15,000 cash received. Entry #RC-2026-0047 saved.</div></div>
                <div className="flex justify-end"><div className="px-2.5 py-1.5 rounded-lg text-[13px] max-w-[70%] shadow-sm" style={{ background: '#D9FDD3', color: '#111B21', borderRadius: '7.5px 0 7.5px 7.5px' }}>Aaj ka report dikhao</div></div>
                <div className="flex justify-start"><div className="px-2.5 py-1.5 rounded-lg text-[13px] max-w-[70%] shadow-sm" style={{ background: '#FFF', color: '#111B21', borderRadius: '0 7.5px 7.5px 7.5px' }}>Sales: Rs.1,20,000 | Received: Rs.55,000 | Trips: 8 | Due: Rs.65,000</div></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Features ── */}
      <section id="features" className="py-32 px-4" style={{ background: '#000' }}>
        <div className="max-w-[980px] mx-auto">
          <h2 className="text-[40px] sm:text-[56px] font-bold tracking-[-0.04em] text-center text-white mb-4">
            Built for Indian business.
          </h2>
          <p className="text-[19px] text-white/50 text-center max-w-xl mx-auto mb-20">
            Purpose-built AI intelligence to manage your entire business through natural conversation.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="#FF2D55" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"/>
                  </svg>
                ),
                title: 'WhatsApp Native',
                desc: 'No new app to download. Your team already knows WhatsApp. Just chat naturally in any language.'
              },
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="#5856D6" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                ),
                title: 'Smart Ledger',
                desc: 'Say "Ramesh se 15000 aaya" and it creates the entry. GST, invoices, receipts — all automatic.'
              },
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="#0A84FF" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"/>
                  </svg>
                ),
                title: 'Business Intelligence',
                desc: 'Daily reports, anomaly detection, and health scores. Know exactly where your money goes.'
              }
            ].map((f, i) => (
              <div key={i} className="rounded-2xl p-8 transition-all hover:scale-[1.02]"
                style={{ background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.06)' }}>
                <div className="mb-5 w-14 h-14 rounded-2xl flex items-center justify-center"
                  style={{ background: 'rgba(255,255,255,.05)' }}>
                  {f.icon}
                </div>
                <h3 className="text-[22px] font-semibold text-white mb-2 tracking-[-0.01em]">{f.title}</h3>
                <p className="text-[15px] leading-relaxed text-white/45">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="py-24 px-4" style={{ background: '#000', borderTop: '1px solid rgba(255,255,255,.04)' }}>
        <div className="max-w-[980px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { num: '< 1s', label: 'Response Time' },
              { num: '₹0', label: 'Setup Cost' },
              { num: 'Multi', label: 'Language Responses' },
              { num: '24/7', label: 'Available' },
            ].map((s, i) => (
              <div key={i}>
                <p className="text-[48px] font-bold tracking-[-0.04em]"
                  style={{ background: 'linear-gradient(135deg, #FF2D55, #5856D6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                  {s.num}
                </p>
                <p className="text-[15px] text-white/40 mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="py-32 px-4 text-center relative overflow-hidden" style={{ background: '#000' }}>
        <div className="absolute inset-0 opacity-20"
          style={{ background: 'radial-gradient(ellipse at center, #5856D6 0%, transparent 70%)' }}/>
        <div className="relative z-10 max-w-2xl mx-auto">
          <h2 className="text-[40px] sm:text-[56px] font-bold tracking-[-0.04em] text-white mb-4">
            Start today.
          </h2>
          <p className="text-[19px] text-white/50 mb-10">
            No credit card. No downloads. Just WhatsApp.
          </p>
          <button onClick={() => navigate('/login')}
            className="px-10 py-4 rounded-full text-[17px] font-medium text-white transition-all hover:scale-[1.02]"
            style={{ background: 'linear-gradient(135deg, #FF2D55, #5856D6)' }}
            data-testid="cta-button">
            Get Started Free
          </button>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="py-6 px-4 text-center" style={{ background: '#000', borderTop: '1px solid rgba(255,255,255,.06)' }}>
        <div className="flex items-center justify-center gap-0.5 mb-2">
          <span className="text-[15px] font-bold tracking-[-0.04em] text-white/40">NOTE</span>
          <span className="text-[15px] font-bold tracking-[-0.04em]"
            style={{ background: 'linear-gradient(135deg, #FF2D55, #5856D6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', opacity: 0.6 }}>HO</span>
        </div>
        <p className="text-[12px] text-white/20">Noteho Technologies Pvt. Ltd.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
